import { inject, Injectable } from '@angular/core'
import type { Observable } from 'rxjs'

import { _Record } from '@app/core/record'
import { HttpService } from '@app/services/http.service'

import type { UploadVoiceParams, UploadVoiceResponse } from '../models/api.model'

@Injectable({ providedIn: 'root' })
export class VoiceMessageService {
  private readonly httpService = inject(HttpService)

  uploadVoice(params: UploadVoiceParams): Observable<UploadVoiceResponse> {
    return this.httpService.post<UploadVoiceResponse>('/voice_messages', params)
  }
}
